// ============================================================
//  src/app/dom.js — Helpers mínimos de DOM para app bootstrap
// ============================================================

export function byId(id) {
    return document.getElementById(id);
}

export function on(id, eventName, handler) {
    byId(id)?.addEventListener(eventName, handler);
}

export function onClick(id, handler) {
    on(id, 'click', handler);
}

export function onChange(id, handler) {
    on(id, 'change', handler);
}

export function onInput(id, handler) {
    on(id, 'input', handler);
}

export function onSubmit(id, handler) {
    on(id, 'submit', handler);
}

export function onOverlayClose(id, closeFn) {
    on(id, 'click', (e) => {
        if (e.target === e.currentTarget) closeFn();
    });
}